import { useMutation } from "@tanstack/react-query";
import api from "../../services/api";
import { useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";


export const useCategoryUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body, params }) => {
      const config = {};
      if (params) config.params = params;
      // Only set multipart header when sending FormData
      if (body instanceof FormData) {
        config.headers = { "Content-Type": "multipart/form-data" };
      }
      const res = await api.put(`/category/update/${id}`, body ?? undefined, config);
      return res.data;
    },
    onSuccess: (_data, variables) => {
      // 'viewcategory' matches useViewCategory's queryKey exactly
      queryClient.invalidateQueries({ queryKey: ["viewcategory"] });
      toast.success("User updated successfully!");
      // 'viewCategoryDetails' matches useViewSingleCategory's queryKey exactly
      if (variables?.id) {
        queryClient.invalidateQueries({ queryKey: ["viewCategoryDetails", variables.id] });
      }
    },
  });
};

